import styled from "styled-components";

export const Container = styled.div`
  background: #e6e6e6;
  /* height: 380px;
  @media (max-width: 1024px) {
    height: auto;
  } */

  .container {
    max-width: 1080px;
    margin: 0 auto;
    padding: 60px 0 55px;
    height: 100%;
    @media (max-width: 1024px) {
      padding: 60px 25px 55px;
    }
    @media (max-width: 768px) {
      padding: 45px 25px;
    }
    @media (max-width: 450px) {
      padding: 25px 25px 33px;
    }
    .item-container {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      @media (max-width: 768px) {
        display: block;
      }
      .row {
        @media (max-width: 768px) {
          &:first-child {
            margin-bottom: 40px;
          }
        }
        .title {
          font-family: "Noto Sans KR";
          font-style: normal;
          font-weight: 700;
          font-size: 21px;
          line-height: 30px;
          color: ${(props) => props.theme.color.default};
          text-transform: uppercase;
          margin-bottom: 16px;

          @media (max-width: 768px) {
            font-weight: 700;
            font-size: 16px;
            line-height: 30px;
          }
        }
        .content {
          letter-spacing: 1px;
          /* text-transform: uppercase; */
          font-family: "Noto Sans KR";
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 32px;
          color: ${(props) => props.theme.color.default};
          @media (max-width: 768px) {
            font-weight: 400;
            font-size: 13px;
            line-height: 25px;
          }
          div {
            display: flex;
          }
          .dot {
            width: 4px;
            min-width: 4px;
            height: 4px;
            margin: 8px 8px 0 8px;
            border-radius: 50%;
            background-color: ${(props) => props.theme.color.default};
          }
        }
        .number-phones {
          font-weight: 700;
          width: max-content;
        }
        .time {
          text-transform: none;
        }
        .english-class {
          line-height: 22px;
          padding-top: 5px;
        }
      }
    }

    .logo {
      /* padding-top: 50px; */
      margin: 27.5px 0 -20px;
      text-align: right;
      @media (max-width: 768px) {
        padding: 80px 0 20px;
        margin: 0;
      }

      @media (max-width: 768px) {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      img {
        max-width: 190px;
      }
    }

    .note {
      font-family: "Noto Sans KR";
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      letter-spacing: 1px;
      text-transform: capitalize;
      color: ${(props) => props.theme.color.default};
      @media (max-width: 768px) {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 12.5px;
        line-height: 18px;
      }
    }
  }
`;
